export default __webpack_public_path__ + "static/media/blubackground.cc2ac0bf.jpg";